import React, { useEffect, useRef, useState } from 'react'
import gsap from 'gsap'
import ImageMedia from './ImageMedia'
import useWindowSize from '../../hooks/useWindowSize'
import { lawwdSymbol } from '../../assets'
import { OtherProjects } from '../../pages/WorkPage'

const SlidingContent = () => {
  const { onMobile } = useWindowSize();
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const animationRef = useRef(null);
  const [speed, setSpeed] = useState(1) // 0 = paused, 1 = fast

  // Set up GSAP infinite animation
  useEffect(() => {
    const el = contentRef.current
    if (!el) return

    animationRef.current = gsap.to(el, {
      xPercent: -50,
      ease: 'linear',
      duration: !onMobile ? 20 : 30, 
      repeat: -1,
    })

    return () => {
      animationRef.current?.kill()
    }
  }, [onMobile])

  // Adjust speed dynamically
  useEffect(() => {
    if (animationRef.current) {
      gsap.to(animationRef.current, {
        timeScale: speed,
        duration: 1,
        ease: 'power2.inOut',
      })
    }
  }, [speed])

  return (
    <div
      ref={containerRef}
      onMouseEnter={() => setSpeed(0.2)} // slow on hover
      onPointerEnter={() => setSpeed(0.2)} // slow on hover
      onMouseLeave={() => setSpeed(1)} // resume normal speed
      onPointerLeave={() => setSpeed(1)} // resume normal speed
      className="relative w-full overflow-hidden cursor-pointer"
    >
      <div
        ref={contentRef}
        className="flex items-center justify-start w-fit gap-10"
      >
        {/* Duplicated content for seamless looping */}
        <ImageMedia src={lawwdSymbol} className="size-6" />
        <OtherProjects prev />
        <ImageMedia src={lawwdSymbol} className="size-6" />
        <OtherProjects prev />
      </div>
    </div>
  )
}

export default SlidingContent
